import { NavLink as RouterNavLink } from "react-router-dom";

import { Box, NavLink, rem } from "@mantine/core";

import classNames from "classnames";

import { TextWrapper } from "@/components/TextWrapper";

import classes from "./Sidebar.module.css";
import { SettingsNavLink } from "./types";

const SIDEBAR_MIN_WIDTH = 240;
const SIDEBAR_MAX_WIDTH = 320;

export default function Sidebar({ links }: { links: SettingsNavLink[] }) {
  const navLinkStyle = { width: 24, height: 24 };
  const navLinkHeight = rem(56);

  return (
    <Box
      py="md"
      visibleFrom="sm"
      miw={SIDEBAR_MIN_WIDTH}
      maw={SIDEBAR_MAX_WIDTH}
      className={classes.sidebar}
    >
      {links.map(({ label, Icon, to, end, isDisabled, section }, index) => {
        const showSection = section !== links[index - 1]?.section;

        return (
          <Box key={label}>
            {showSection && (
              <TextWrapper
                px="sm"
                pt="md"
                pb="xs"
                size="sm"
                c="dark.3"
                variant="bold"
                data-testid={`settings-sidebar-section-${section}`}
              >
                {section}
              </TextWrapper>
            )}
            <NavLink
              h={navLinkHeight}
              disabled={isDisabled}
              label={<TextWrapper>{label}</TextWrapper>}
              leftSection={<Icon style={navLinkStyle} />}
              renderRoot={({ className, ...props }) => {
                return (
                  <RouterNavLink
                    to={to}
                    end={end}
                    className={({ isActive }) =>
                      isActive ? classNames(className, classes.navLinkActive) : className
                    }
                    {...props}
                  />
                );
              }}
            />
          </Box>
        );
      })}
    </Box>
  );
}
